import * as effects from 'redux-saga/effects'
import { State } from './store'
import { setItem } from './io'
import { GetInfoResult, StateC } from './Info'

function* saveInfoSaga(_: GetInfoResult) {
  const i: State['info'] = yield effects.select(({ info }: State) => info)
  setItem('info', i, StateC)()
}

export function* saga() {
  yield effects.throttle(5000, 'get_info_result', saveInfoSaga)
}
